import { render, staticRenderFns } from "./FieldConstructor.vue?vue&type=template&id=0a2dcdd2&scoped=true"
import script from "./FieldConstructor.vue?vue&type=script&lang=js"
export * from "./FieldConstructor.vue?vue&type=script&lang=js"
import style0 from "./FieldConstructor.vue?vue&type=style&index=0&id=0a2dcdd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2dcdd2",
  null
  
)

export default component.exports